import React from 'react';
import styled from 'styled-components';

const StyledManufacturer = styled.div`
        display: block;
        font-size: 0.81em;
        line-height: 1;
`;

const Text = () => (
    <StyledManufacturer>
        Hersteller:
        <br/>
        Becker & Karsten UG (haftungsbeschränkt)
        <br/>
        Sandhauser Str. 107, 13505 Berlin<br/>
        www.stoff.love<br/>
        Telefon: +49 30 609851965
    </StyledManufacturer>
  );

export default Text;



// WEBPACK FOOTER //
// ./src/components/common/Manufacturer.js